import React, { useState } from "react";
import { Formik, Form } from "formik";
import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import * as Yup from "yup";
import useUrls from "../../hooks/useUrls";
import { logUserIn } from "../../store/slices/auth";
import TextInput from "../form/TextInput";
import Box from "../layout/Box";
import http from "../../services/httpService";

import { useMutation } from "react-query";
import ButtonSubmit from "../form/ButtonSubmit";
import LogoutMessage from "./LogoutMessage";

const SignupForm = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState("");
  const { apiUrl } = useUrls();

  const mutation = useMutation((data) => http.post(`${apiUrl}/users`, data), {
    onSuccess: (data) => {
      handleSignup(data);
    },
    onError: (error) => {
      setErrorMessage(error.response.data.error);
    },
  });

  const handleSignup = ({ data, headers }) => {
    dispatch(logUserIn(data));
    localStorage.setItem("token", headers["x-auth-token"]);
    history.replace(`/users/${data.user.username}`);
  };

  return (
    <Box title={"sign up"} id={"signup"} boxWidth={"20.25rem"}>
      <LogoutMessage />
      <Formik
        initialValues={{
          firstName: mutation.variables?.firstName || "",
          lastName: mutation.variables?.lastName || "",
          email: mutation.variables?.email || "",
          username: mutation.variables?.username || "",
          password: "",
        }}
        validateOnMount={true}
        validationSchema={Yup.object({
          firstName: Yup.string().required("Required"),
          lastName: Yup.string().required("Required"),
          email: Yup.string()
            .email("Invalid email address")
            .required("Required"),
          username: Yup.string().required("Required"),
          password: Yup.string()
            .min(8, "Password must be at least 8 characters long.")
            .required("Required"),
        })}
        onSubmit={mutation.mutate}
      >
        {({ isValid }) =>
          mutation.isLoading ? (
            <span>Signing you up...</span>
          ) : (
            <>
              {mutation.isError ? (
                <div className={"alert"}>{errorMessage}</div>
              ) : null}
              {
                <Form>
                  <TextInput name={"firstName"} label={"First name"} />
                  <TextInput name={"lastName"} label={"Last name"} />
                  <TextInput
                    name={"email"}
                    type={"email"}
                    label={"Email address"}
                  />
                  <TextInput name={"username"} label={"Username"} />
                  <TextInput
                    name={"password"}
                    type={"password"}
                    label={"Password"}
                  />
                  <ButtonSubmit label={"Sign up"} formIsValid={isValid} />
                  <p>
                    Already have an account?{" "}
                    <Link to={"/login"}>Log in here</Link>.
                  </p>
                </Form>
              }
            </>
          )
        }
      </Formik>
    </Box>
  );
};

export default SignupForm;
